import { useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { getAuthenticatedUser, indexPendingFriendshipRequests } from "~/features/auth/api/auth/authApiDispatchers.ts";

export const AUTHENTICATED_USER_QUERY_KEY = ["authenticatedUser"];

export const useAuthenticatedUserQuery = (enabled: boolean = true) =>
    useQuery({
        queryKey: AUTHENTICATED_USER_QUERY_KEY,
        queryFn: () => getAuthenticatedUser().then(getDataFromResponse),
        enabled,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        staleTime: Infinity,
    });

export const AUTHENTICATED_USER_PENDING_FRIENDSHIP_REQUESTS_QUERY_KEY = [
    ...AUTHENTICATED_USER_QUERY_KEY,
    "pendingFriendshipRequests",
];

export const useAuthenticatedUsersPendingFriendshipRequests = () =>
    useQuery({
        queryKey: AUTHENTICATED_USER_QUERY_KEY,
        queryFn: () => indexPendingFriendshipRequests().then(getDataFromResponse),
    });
